import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Clock, Repeat } from 'lucide-react';
import { GlassCard } from '@/components/GlassCard';
import { calcTotalDuration, totalRounds, formatTime } from '@/models/models';

const levelStyle = {
  Beginner: { color: '#22C55E', label: 'Beginner' },
  Intermediate: { color: '#38BDF8', label: 'Intermediate' },
  Advanced: { color: '#EF4444', label: 'Advanced' },
};

export const PresetCard = ({ preset, onStart, testId }) => {
  const duration = calcTotalDuration(preset);
  const rounds = totalRounds(preset);
  const lvl = levelStyle[preset.level] || levelStyle.Intermediate;

  return (
    <motion.div
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2 }}
      onClick={onStart}
      className="cursor-pointer"
      data-testid={testId}
    >
      <GlassCard className="flex h-full flex-col gap-3">
        <div className="flex items-start justify-between">
          <h3 className="text-lg font-bold text-white">{preset.name}</h3>
          <span
            className="rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider"
            style={{ background: `${lvl.color}22`, color: lvl.color }}
          >
            {lvl.label}
          </span>
        </div>

        <div
          className="h-1.5 w-full rounded-full"
          style={{
            background: `linear-gradient(90deg, ${preset.accent}, ${preset.accent}22)`,
          }}
        />

        <div className="mt-auto flex items-center justify-between text-sm text-[#CBD5E1]">
          <span className="flex items-center gap-1.5 font-semibold text-white tabular-nums">
            <Clock size={15} className="text-[#38BDF8]" />
            {formatTime(duration)}
          </span>
          <span className="flex items-center gap-1.5">
            <Repeat size={15} className="text-[#F59E0B]" />
            {rounds}
          </span>
          <span className="flex items-center gap-1.5">
            <Flame size={15} className="text-[#EF4444]" />
            {preset.calories} kcal
          </span>
        </div>
      </GlassCard>
    </motion.div>
  );
};

export default PresetCard;
